if (process.env.NODE_ENV === 'development') {
    const { weakStart } = require('@hotjar/webapp/api-mocks/browser');
    // necessary for history-based routing
    const options = { serviceWorker: { url: '/mockServiceWorker.js' }, onUnhandledRequest: 'bypass' };
    weakStart(options);
}

window.UAParser = require('ua-parser-js');
window.Clipboard = require('clipboard');

require('./css/recording.scss');
window.injectHotjarTrackingCode = require('../app/js/other/hotjar-tracking-code.js').injectHotjarTrackingCode;
require('./js/controllers/shared-recording-react.jsx');
